import React, { useState, useEffect } from "react";
import useModal from "hook/useModal";

// css
import "assets/style/elements/split-bar.scss";

function Element({ className }) {
  return (
    <hr className={"split-bar " + className} />
  );
}

export default Element;
